// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2MReX","title":"Header_title__19jXh","side":"Header_side__1RkxQ"};